import { NaModuleIdEnum } from '../../enums/moduleId';
import { HttpClient } from '../HttpClient';
/**
 * * Get User's Accessible Routes
 */
const DEFAULT_MODULE_ID = NaModuleIdEnum.attendanceLogs;
export const GetRouteAccess = async (moduleId = DEFAULT_MODULE_ID) => {
  try {
    const { data } = await HttpClient.get('api/users/routeaccess', {
      params: { ModuleId: moduleId },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
